import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import type { Maybe } from "@entrilia/shared/types.ts";

interface Props {
  customFieldValue: Maybe<string>;
  originalFieldValue: string;
  readonly?: boolean;
  label: string;
  defaultLabel: string;
  shouldShowDefaultLabel: boolean;
  onRenameClick: () => void;
}
export default function ViewField({
  customFieldValue,
  originalFieldValue,
  onRenameClick,
  readonly,
  label,
  defaultLabel,
  shouldShowDefaultLabel,
}: Props) {
  return (
    <>
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Box sx={{ gap: 0.75, width: "36px" }}>
            <Typography>{label}:</Typography>
          </Box>
          <Typography variant="subtitle1" component="span" noWrap>
            {customFieldValue || originalFieldValue}
          </Typography>
        </Box>
        {shouldShowDefaultLabel && (
          <Typography noWrap variant="caption">
            {defaultLabel} - {originalFieldValue}
          </Typography>
        )}
      </Box>
      {readonly !== true && (
        <Tooltip title="Rename" placement="bottom" arrow disableInteractive>
          <IconButton onClick={onRenameClick}>
            <DriveFileRenameOutlineIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}
